/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { useSessionError } from '@/data/Content/SessionErrorDialog';
import { FC, useEffect } from 'react';

export const SessionErrorDialog: FC = () => {
	const { message } = useSessionError();
	useEffect(() => {
		if (message) {
			window.location.reload();
		}
	}, [message]);
	return null;
};
